export default __webpack_public_path__ + "static/media/7.77aed977.png";